import type { OverviewMapPoint, OverviewNoCoordinatesRecord } from '../../domain/overviewMapPoint'

/**
 * Jeu déterministe : au moins un point par catégorie, deux points superposés
 * (désambiguïsation, ticket §14), et les enregistrements « sans position »
 * comptés à part — jamais géocodés ici non plus.
 */
export const overviewMapFixturePoints: OverviewMapPoint[] = [
  {
    id: 'client:demo-1',
    category: 'GREEN',
    clientId: 'demo-client-1',
    clientName: 'Jean Tremblay',
    phone: '450-555-0102',
    contractId: 'demo-contract-1',
    contractNumber: 'CTR-260000482',
    address: '123 rue Exemple, Saint-Jérôme, QC',
    latitude: 45.7807,
    longitude: -74.0037,
    totalCents: 114975,
    standardDrivewayCapacity: 2,
    season: '2026-2027',
    clientType: 'residentiel',
    clientSince: 2021,
    servicesSummary: 'Déneigement, Sable et sel',
  },
  {
    id: 'client:demo-2',
    category: 'GREEN',
    clientId: 'demo-client-2',
    clientName: 'ABC Gestion Inc.',
    phone: '450-555-0177',
    contractId: 'demo-contract-2',
    contractNumber: 'CTR-260000501',
    address: '10 boulevard Central, Saint-Jérôme, QC',
    // Superposé avec le point suivant : désambiguïsation au clic (ticket §14).
    latitude: 45.782,
    longitude: -74.005,
    totalCents: 205000,
    standardDrivewayCapacity: 4,
    season: '2026-2027',
    clientType: 'commercial',
    clientSince: 2019,
    servicesSummary: 'Déneigement stationnement, Trottoirs',
  },
  {
    id: 'lead:demo-overlap',
    category: 'BLUE',
    leadId: 'demo-lead-overlap',
    leadName: 'Nouvelle Opportunité',
    phone: '450-555-0199',
    address: '10 boulevard Central, Saint-Jérôme, QC',
    latitude: 45.782,
    longitude: -74.005,
    status: 'NEW',
    origin: 'landing',
  },
  {
    id: 'contract:demo-3',
    category: 'YELLOW',
    clientId: 'demo-client-3',
    clientName: 'Jean Tremblay',
    phone: '450-555-0103',
    contractId: 'demo-contract-3',
    contractNumber: 'CTR-260000512',
    address: '123 rue Exemple, Saint-Jérôme, QC',
    latitude: 45.7841,
    longitude: -74.0091,
    totalCents: 114975,
    statusV2: 'VIEWED',
    sentAt: '2026-08-24T14:00:00Z',
    nextFollowUpAt: '2026-08-27T14:00:00Z',
  },
  {
    id: 'contract:demo-4',
    category: 'YELLOW',
    clientId: 'demo-client-4',
    clientName: 'Marie Roy',
    phone: '450-555-0188',
    contractId: 'demo-contract-4',
    contractNumber: 'CTR-260000513',
    address: '455 rue de la Neige, Saint-Jérôme, QC',
    latitude: 45.7755,
    longitude: -74.012,
    totalCents: 45500,
    statusV2: 'PENDING_CLIENT',
  },
  {
    id: 'lead:demo-1',
    category: 'BLUE',
    leadId: 'demo-lead-1',
    leadName: 'Marie Tremblay',
    phone: '450-555-0301',
    address: '1450 rue des Pins, Saint-Jérôme, QC',
    latitude: 45.7893,
    longitude: -74.001,
    status: 'NEW',
    origin: 'landing',
    nextReminderAt: '2026-08-27T14:00:00Z',
  },
]

/** Inclus seulement quand le drapeau « afficher les perdues » est actif. */
export const overviewMapFixtureLostPoint: OverviewMapPoint = {
  id: 'lead:demo-lost',
  category: 'BLUE',
  leadId: 'demo-lead-lost',
  leadName: 'Occasion Perdue',
  phone: '450-555-0311',
  address: '2 rue Refusée, Saint-Jérôme, QC',
  latitude: 45.79,
  longitude: -74.02,
  status: 'LOST',
  origin: 'landing',
}

export const overviewMapFixtureNoCoordinates: OverviewNoCoordinatesRecord[] = [
  { id: 'client:demo-no-coords', category: 'GREEN', label: 'Client Sans-Position' },
]
